import { DataGetUseCase } from '../../application/';

export default class DataGetService {

    async execute(event) {
        console.log('surveyApi Service: ', event);
        const data = await DataGetUseCase(event);

        return data;
    }
}
